(ns ycweb.app.pos.keepaside.keepaside
  (:require
   [clojure.set :as set]
   [clojure.string :as str]
   [inflections.core :as inflections]
   [rum.core :as rum]
   [ycweb.components.cards :as cards]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.slats :as slats]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.sound :as sound]))

(def inbound-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :pick-items :title "Choose items to pick"}
     {:key :scan-items :title "Scan items"}
     {:key :move-items :title "Move items"}
     {:key :done :title "Done"}]))

(def outbound-steps
  (forms/setup-steps
    [{:key :scan-code :title "Scan Code"}
     {:key :choose-order :title "Choose order"}
     {:key :scan-items :title "Scan items"}
     {:key :move-items :title "Move items"}
     {:key :done :title "Done"}]))

(def replenish-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :pick-items :title "Choose items to put back"}
     {:key :scan-items :title "Scan items"}
     {:key :move-items :title "Move items"}
     {:key :done :title "Done"}]))

(def all-request-steps
  (forms/setup-steps
    [{:key :start :title "Get Started"}
     {:key :request-list :title "All Requests"}
     {:key :view-request :title "View Request"}]))

(defn keepaside-inbound-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Can't Find"
       :action :keepaside/inbound-item-missing-confirm
       :style {:full true :large true :negative true :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :keepaside/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defn keepaside-replenish-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Can't Find"
       :action :keepaside/replenish-item-missing-confirm
       :style {:full true :large true :negative true :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :keepaside/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :keepaside/inbound-item-missing-confirm [app-atom _ _]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :inbound :items])
        selected-variation-uuid (cmn/curact app-atom [:keep-aside :inbound :selected-variation-uuid])
        selected-variaton (get items-gpd selected-variation-uuid)
        max-count (+ (count selected-variaton) 1)]

    (grid/confirm-modal app-atom
      {:title "Confirm item missing?"
       :text
       [:div
        (forms/select
          "Select quantity missing:"
          (rum/cursor-in app-atom [:keep-aside :inbound :selected-variation-missing-qty])
          (into
            []
            (for [x (range 1 max-count)]
              {:value x :text x}))
          {:default (count selected-variaton)})

        [:p [:b "Note: "]
         "This will notify the customer that the item is not available, as well as trigger a stocktake for this item and
          temporarily mark the item as Out of Stock on the website Keep Aside feature."]]
       :confirm-key :keepaside/inbound-item-missing})))

(defmethod grid/action :keepaside/inbound-item-missing [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [items-gpd (get-in @app-atom [:keep-aside :inbound :items])
        selected-variation-uuid (get-in @app-atom [:keep-aside :inbound :selected-variation-uuid])
        selected-variation-missing-qty (get-in @app-atom [:keep-aside :inbound :selected-variation-missing-qty])
        selected-variaton (get items-gpd selected-variation-uuid)]

    (comms/send :pos/keepaside-inbound-item-missing
      {:variation-uuid selected-variation-uuid
       :qty (min (count selected-variaton) selected-variation-missing-qty)})))

(defmethod comms/receive :pos/keepaside-inbound-item-missing [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (grid/dispatch-action app-atom :keepaside/items-list nil))

(defmethod grid/action :keepaside/replenish-item-missing-confirm [app-atom _ _]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :replenish :items])
        selected-variation-uuid (cmn/curact app-atom [:keep-aside :replenish :selected-variation-uuid])
        selected-variaton (get items-gpd selected-variation-uuid)
        max-count (+ (count selected-variaton) 1)]

    (grid/confirm-modal app-atom
      {:title "Confirm item missing?"
       :text
       [:div
        (forms/select
          "Select quantity missing:"
          (rum/cursor-in app-atom [:keep-aside :replenish :selected-variation-missing-qty])
          (into
            []
            (for [x (range 1 max-count)]
              {:value x :text x}))
          {:default (count selected-variaton)})

        [:p [:b "Note: "] "This will trigger a stocktake for this item."]]
       :confirm-key :keepaside/replenish-item-missing})))

(defmethod grid/action :keepaside/replenish-item-missing [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (let [items-gpd (get-in @app-atom [:keep-aside :replenish :items])
        selected-variation-uuid (get-in @app-atom [:keep-aside :replenish :selected-variation-uuid])
        selected-variation-missing-qty (get-in @app-atom [:keep-aside :replenish :selected-variation-missing-qty])
        selected-variaton (get items-gpd selected-variation-uuid)]

    (comms/send :pos/keepaside-replenish-item-missing
      {:variation-uuid selected-variation-uuid
       :qty (min (count selected-variaton) selected-variation-missing-qty)})))

(defmethod comms/receive :pos/keepaside-replenish-item-missing [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (grid/dispatch-action app-atom :keepaside/replenish-items-list nil))

(rum/defc keepaside-screen-start < rum/reactive
  [app-atom]
  (let [keep-aside-alerts (cmn/curact app-atom [:alerts :keep-aside])]
    (w/wrapper app-atom "Keep Aside" {}
      [[:h2.u-text-center
        {:class (u/bem :heading [:standard])}
        "What would you like to do?"]
       [:div.slats
        (slats/function-slat
          {:label "Incoming Requests"
           :alert? (when (:inbound? keep-aside-alerts) [:div.tile__alert [:i {:class (u/bem :icon [:3-2 :error :block])}]])
           :on-click #(grid/dispatch-action app-atom :keepaside/items-list nil)})
        (slats/function-slat
          {:label "Help Customer"
           :on-click #(grid/dispatch-action app-atom :keepaside/outbound-qrcode nil)})
        (slats/function-slat
          {:label "Book Stock Back In"
           :alert? (when (:expired? keep-aside-alerts) [:div.tile__alert [:i {:class (u/bem :icon [:3-2 :error :block])}]])
           :on-click #(grid/dispatch-action app-atom :keepaside/replenish-items-list nil)})
        (slats/function-slat
          {:label "View All Requests"
           :on-click #(grid/dispatch-action app-atom :keepaside/all-requests-list nil)})]]

      []

      [])))

(defmethod flow/render-screen :keepaside [app-atom]
  (keepaside-screen-start app-atom))

(defmethod comms/receive :pos/keepaside-alerts [app-atom e]
  (swap! app-atom assoc-in [:alerts :keep-aside] (:alerts e)))


;; ===========================================
;; ============ Inbound Start ================
;; ===========================================
;; Inbound 01 (Incoming Requests list)
(rum/defc keepaside-inbound-requests < rum/reactive
  [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :inbound :items])]
    (w/wrapper app-atom "Keep Aside" {:steps inbound-steps :step :pick-items}

      (cond
        (not-empty items-gpd)
        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:flush :standard])}
           "Keep Aside Requests"]]

         [:div.slats
          (map
            (fn [[v-uuid item]]
              (let [details (:variation/details (:keep-aside-item/variation (first item)))]
                (cards/product-card
                  {:hide-price? true :hide-options? true :stocktake-preview? true}
                  {:image {:public_id (:doc/public-id (:ent/image (:item-line/variation details)))}
                   :on-click
                   #(grid/dispatch-action app-atom :keepaside/inbound-scans {:v-uuid v-uuid})
                   :keepaside_needed (str (count item) " needed")
                   :brand (:product/brand-name (:item-line/product details))
                   :title (:product/name-ex-brand (:item-line/product details))
                   :feature (:variation/features (:item-line/variation details))})))
            items-gpd)]]

        :else
        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "There are no items to keep aside"]

          [:div
           [:i.u-block-center
            {:class
             (u/bem
               :icon
               [:block :enormous :light-force :emoticon-happy :is-dark])}]]]])

      [(when-not (not-empty items-gpd)
         [:aside.page-body__footnote
          [:p.u-text-center
           {:class (u/bem :paragraph [:flush])}
           "The POS app will notify you of any Keep Aside orders. There's nothing here for now."]])]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :keepaside/inbound-requests [app-atom]
  (keepaside-inbound-requests app-atom))

(defmethod grid/action :keepaside/items-list [app-atom {:keys [scan]}]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom update :keep-aside dissoc :inbound)
  (comms/send :pos/keepaside-items-list
    {:session-uuid (:session-uuid @app-atom) :barcode scan}))

(defmethod comms/receive :pos/keepaside-items-list [app-atom e]
  (toaster/close-subtle-progress app-atom)

  (swap! app-atom assoc-in [:keep-aside :inbound :items] (:items e))
  (t/transition-next app-atom :keepaside/inbound-requests))


;; Inbound 02 (Scans)
(defmethod grid/action :keepaside/inbound-scans [app-atom {:keys [v-uuid]}]
  (swap! app-atom assoc-in [:keep-aside :inbound :selected-variation-uuid] v-uuid)
  (t/transition-next app-atom :keepaside/inbound-scan))

(rum/defc keepaside-inbound-scans < rum/reactive [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :inbound :items])
        selected-variation-uuid (cmn/curact app-atom [:keep-aside :inbound :selected-variation-uuid])
        selected-variaton (get items-gpd selected-variation-uuid)
        details (:variation/details (:keep-aside-item/variation (first selected-variaton)))
        scanned-qty (cmn/curact app-atom [:keep-aside :inbound :scanned-variations selected-variation-uuid :scanned-qty])]

    (w/wrapper app-atom "Keep Aside"
      {:steps inbound-steps
       :step :scan-items
       :modal-fn keepaside-inbound-menu-modal}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Scan Items"]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count
           (str (or scanned-qty 0) " / " (count selected-variaton))]
          [:img.product-card__image
           {:src (u/cloudinary (:doc/public-id (:ent/image (:item-line/variation details))) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand (:product/brand-name (:item-line/product details))]
           [:span.product-card__name (:product/name-ex-brand (:item-line/product details))]]
          (when (u/presence (:variation/features (:item-line/variation details)))
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation (:variation/features (:item-line/variation details))]])
          [:div.product-card__barcode
           "Code: " [:b.u-barcode.u-block (:variation/code (:item-line/variation details))]]]]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when (= (or scanned-qty 0) (count selected-variaton))
           #(t/transition-next app-atom :keepaside/inbound-move))}))))

(defmethod flow/render-screen :keepaside/inbound-scan [app-atom]
  (keepaside-inbound-scans app-atom))

(defmethod flow/barcode-dispatch-screen :keepaside/inbound-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :keepaside/variation-scan {:scan scan}))

(defmethod grid/action :keepaside/variation-scan [app-atom {:keys [scan]} _]
  (sound/play :scan)
  (toaster/open-subtle-progress app-atom)

  (let [items-gpd (get-in @app-atom [:keep-aside :inbound :items])
        current-variation-uuid (get-in @app-atom [:keep-aside :inbound :selected-variation-uuid])
        scanned-variations (get-in @app-atom [:keep-aside :inbound :scanned-variations])
        max-count (count (get items-gpd current-variation-uuid))
        scanned-variation-qty (:scanned-qty (get scanned-variations current-variation-uuid))]

    (comms/send :pos/keepaside-variation-scan
      {:scan scan
       :max-scans max-count
       :scanned-qty (or scanned-variation-qty 0)
       :current-variation-uuid current-variation-uuid})))

(defmethod comms/receive :pos/keepaside-variation-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:success e)
    (swap! app-atom assoc-in
      [:keep-aside :inbound :scanned-variations (:current-variation-uuid e) :scanned-qty]
      (:scanned-qty e))))


;; Inbound 03 (Move items)
(rum/defc keepaside-inbound-move < rum/reactive
  [app-atom]
  (let [confirmed-atom (rum/cursor-in app-atom [:keep-aside :inbound :confirmed?])
        confirmed? (rum/react confirmed-atom)]
    (w/wrapper app-atom "Keep Aside" {:steps inbound-steps :step :move-items}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Move Items To Store Room"]]
       [:div
        {:class (u/bem :section [:medium])}
        [:i.u-block-center
         {:class (u/bem :icon [:light-force :location :enormous :block])}]
        [:div.u-margin-top-24
         (feedback/action-feedback :info "Moved items to store room?" "" confirmed-atom {})]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when confirmed?
           #(grid/dispatch-action app-atom :keepaside/inbound-done {}))}))))

(defmethod flow/render-screen :keepaside/inbound-move [app-atom]
  (keepaside-inbound-move app-atom))


;; Inbound 04 (Finish)
(rum/defc keepaside-inbound-done < rum/reactive
  [app-atom]
  (w/wrapper app-atom "Keep Aside" {:steps inbound-steps :step :done}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:large :flush])}
        [:b "You've kept that aside."]]
       [:p.u-text-center
        {:class (u/bem :paragraph [:flush])}
        "We'll notify the customer by email when all their items are ready for them to view."]]]]

    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush :large])}
       [:a.text-link {:href "#" :on-click #(t/transition-next app-atom :keepaside)}
        "Done moving items for now"]]]]

    (grid/pos-call-to-action
      {:single-text "Next Item"
       :single-icon-right :arrow-right
       :single-fn #(grid/dispatch-action app-atom :keepaside/items-list nil)})))

(defmethod flow/render-screen :keepaside/inbound-done [app-atom]
  (keepaside-inbound-done app-atom))


(defmethod grid/action :keepaside/inbound-done [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [current-variation-uuid (get-in @app-atom [:keep-aside :inbound :selected-variation-uuid])
        scanned-qty (:scanned-qty (get-in @app-atom [:keep-aside :inbound :scanned-variations current-variation-uuid]))]

    (comms/send :pos/keepaside-inbound-move-variations
      {:variation-uuid current-variation-uuid
       :scanned-qty scanned-qty})))

(defmethod comms/receive :pos/keepaside-inbound-move-variations [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:success e)
    (swap! app-atom update :keep-aside dissoc :inbound)
    (t/transition-next app-atom :keepaside/inbound-done)))


;; ===========================================
;; ============ Inbound End ==================
;; ===========================================


;; ===========================================
;; ============ Outbound Start ===============
;; ===========================================
;; Outbound 01 (QR Code)
(defn collections-lookup [app-atom]
  (swap! app-atom update-in [:keep-aside :outbound] dissoc :lookup)
  (toaster/open-subtle-progress app-atom)

  (comms/send :pos/keepaside-lookup
    {:lookup (get-in @app-atom [:keep-aside :outbound :name])}))

(defonce collection-lifecycle-listener
  (cmn/lifecycle-listener :keep-aside-lookup/setup :setup
    (fn [app-atom]
      (cmn/debounce-in app-atom [:keep-aside :outbound :name]
        500
        #(when (and (>= (count %) 2))
           (collections-lookup app-atom))))))

(defmethod flow/barcode-dispatch-screen :keepaside/outbound-qrcode [_ app-atom scan]
  (toaster/open-subtle-progress app-atom)
  (swap! app-atom assoc-in [:keep-aside :outbound :scan-name] scan)
  (comms/send :pos/keepaside-lookup
    {:lookup-scan scan}))

(defmethod comms/receive :pos/keepaside-lookup [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (or (= (get-in @app-atom [:keep-aside :outbound :name]) (:lookup e)) (= :order (:found e)))
    (swap! app-atom assoc-in [:keep-aside :outbound :lookup] e)))

(rum/defc keepaside-outbound-qrcode < rum/reactive
  [app-atom]
  (let [collection-atom (rum/cursor-in app-atom [:keep-aside :outbound])
        lookup (cmn/curact collection-atom :lookup)
        {:keys [found ready? order]} lookup]

    (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :scan-code}
      [[:form.u-margin-top-24
        [:div
         {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          "Scan Keep Aside QR Code"
          [:span.u-hidden-from-view " "]
          [:span.heading__subtext "or enter manually in the field below"]]

         ;;todo - adjust hint text and label when we can generate short order numbers
         (forms/input "" "e.g. jane.smith@domain.com" (rum/cursor collection-atom :name)
           {:hint "e.g. jane.smith@domain.com"
            :type :barcode})

         ;; TODO: don't show this block until input has been touched.
         ;; At the moment it's giving a red error message before doing anything.
         [:div.u-margin-top-24
          (cond
            (and found (not ready?))
            (feedback/feedback
              :error "Keep Aside Order not ready"
              "This order is not ready for collection yet.")

            found
            (feedback/feedback
              :success "Keep Aside User Found"
              (str "Press Next to process Keep Aside Order for " (cmn/curact collection-atom [:lookup :order :contact/email])))

            :else
            (feedback/feedback
              :error "No order or user found"
              "Please enter the complete order number or complete email address"))]]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :keepaside)
         :right-text "Next"
         :right-fn
         (when (and found ready?)
           #(grid/dispatch-action app-atom :keepaside/outbound-results {:order-uuid (:ent/uuid order)}))}))))

(defmethod flow/render-screen :keepaside/outbound-qrcode [app-atom]
  (keepaside-outbound-qrcode app-atom))


(defmethod grid/action :keepaside/outbound-qrcode [app-atom {:keys [scan]}]
  (swap! app-atom update :keep-aside dissoc :outbound)
  (t/transition-next app-atom :keepaside/outbound-qrcode))


;; Outbound 02 (Results)
(rum/defc keepaside-outbound-results < rum/reactive
  [app-atom]
  (let [order-atom (rum/cursor-in app-atom [:keep-aside :outbound :lookup :order])
        order (rum/react order-atom)

        item-count
        (reduce
          (fn [acc [_ items]]
            (+ acc (count items)))
          0
          (:items order))]

    (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :choose-order}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Search results for"
         [:span.u-hidden-from-view " "]
         [:span.u-block (:contact/email order)]]]

       [:div.slats
        (slats/collection-order-slat
          ;;todo - KA-order-number when we can generate them
          {:firstname (:contact/firstname order)
           :lastname (:contact/lastname order)
           ;:ref "YCKA4619679"
           :is-request? true
           :email (:contact/email order)
           :boxes-count item-count}
          {:on-click #(grid/dispatch-action app-atom :keepaside/outbound-scans-calculate {})})]]

      []

      [(grid/pos-call-to-action
         {:left-fn #(t/transition-next app-atom :keepaside/outbound-qrcode)
          :right-plain true})])))

(defmethod flow/render-screen :keepaside/outbound-results [app-atom]
  (keepaside-outbound-results app-atom))

(defmethod grid/action :keepaside/outbound-results [app-atom {:keys [order-uuid]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/keepaside-collect-order-list
    {:order-uuid order-uuid}))

(defmethod comms/receive :pos/keepaside-collect-order-list [app-atom e]
  (toaster/close-subtle-progress app-atom)

  (swap! app-atom assoc-in [:keep-aside :outbound :lookup :order :items] (:items e))
  (t/transition-next app-atom :keepaside/outbound-results))


;; Outbound 03 (Scans)
(rum/defc keepaside-outbound-scans < rum/reactive [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :outbound :lookup :order :items])
        selected-variation-uuid (cmn/curact app-atom [:keep-aside :outbound :selected-variation-uuid])
        more-items? (cmn/curact app-atom [:keep-aside :outbound :more-items?])
        selected-variaton (get items-gpd selected-variation-uuid)
        details (:variation/details (:keep-aside-item/variation (first selected-variaton)))
        scanned-qty (cmn/curact app-atom [:keep-aside :outbound :items-scanned selected-variation-uuid :scanned-qty])]

    (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :scan-items}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Scan Items"]]

       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count
           (str (or scanned-qty 0) " / " (count selected-variaton))]
          [:img.product-card__image
           {:src (u/cloudinary (:doc/public-id (:ent/image (:item-line/variation details))) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand (:product/brand-name (:item-line/product details))]
           [:span.product-card__name (:product/name-ex-brand (:item-line/product details))]]
          (when (u/presence (:variation/features (:item-line/variation details)))
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation (:variation/features (:item-line/variation details))]])
          [:div.product-card__barcode
           "Code: " [:b.u-barcode.u-block (:variation/code (:item-line/variation details))]]]]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when (= (or scanned-qty 0) (count selected-variaton))
           (if more-items?
             #(grid/dispatch-action app-atom :keepaside/outbound-scans-calculate {})
             #(t/transition-next app-atom :keepaside/outbound-scanlist)))}))))

(defmethod flow/render-screen :keepaside/outbound-scans [app-atom]
  (keepaside-outbound-scans app-atom))

(defmethod grid/action :keepaside/outbound-scans-calculate [app-atom {:keys [scan]} _]
  (let [items-gpd (get-in @app-atom [:keep-aside :outbound :lookup :order :items])
        items-scanned (get-in @app-atom [:keep-aside :outbound :items-scanned])
        next-items (set/difference (set (keys items-gpd)) (set (map first items-scanned)))]

    (swap! app-atom
      #(->
         %
         (assoc-in [:keep-aside :outbound :selected-variation-uuid] (first next-items))
         (assoc-in [:keep-aside :outbound :more-items?] (> (count next-items) 1))))

    (t/transition-next app-atom :keepaside/outbound-scans)))


(defmethod flow/barcode-dispatch-screen :keepaside/outbound-scans [_ app-atom scan]
  (grid/dispatch-action app-atom :keepaside/outbound-variation-scan {:scan scan}))

(defmethod grid/action :keepaside/outbound-variation-scan [app-atom {:keys [scan]} _]
  (sound/play :scan)
  (toaster/open-subtle-progress app-atom)

  (let [items-gpd (get-in @app-atom [:keep-aside :outbound :lookup :order :items])
        current-variation-uuid (get-in @app-atom [:keep-aside :outbound :selected-variation-uuid])
        scanned-variations (get-in @app-atom [:keep-aside :outbound :items-scanned])
        max-count (count (get items-gpd current-variation-uuid))
        scanned-variation-qty (:scanned-qty (get scanned-variations current-variation-uuid))]

    (comms/send :pos/keepaside-outbound-variation-scan
      {:scan scan
       :max-scans max-count
       :scanned-qty (or scanned-variation-qty 0)
       :current-variation-uuid current-variation-uuid})))

(defmethod comms/receive :pos/keepaside-outbound-variation-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:success e)
    (swap! app-atom assoc-in
      [:keep-aside :outbound :items-scanned (:current-variation-uuid e) :scanned-qty]
      (:scanned-qty e))))


;; Outbound 04 (Scan list)
(rum/defc keepaside-product-slat < rum/reactive [{:keys [qty brand product feature]}]
  [:article.slat.product-slat
   [:div.product-slat__qty [:span qty]]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1
       {:class (u/bem :product-slat__title [:small])}
       [:b.u-block brand]
       [:span.u-block product]
       [:span.u-hidden-from-view " | "]
       [:span.u-block feature]]]]]])

(rum/defc keepaside-outbound-scanlist < rum/reactive
  [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :outbound :lookup :order :items])
        items-scanned (cmn/curact app-atom [:keep-aside :outbound :items-scanned])

        item-count
        (reduce
          (fn [acc [_ items]]
            (+ acc (count items)))
          0
          items-gpd)

        scanned-count
        (reduce
          (fn [acc [_ scan]]
            (+ acc (:scanned-qty scan)))
          0
          items-scanned)]

    (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :scan-items}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Total Items Fetched: " scanned-count "/" item-count]]

       [:div.slats
        (map
          (fn [[v-uuid scanned]]
            (let [details (:variation/details (:keep-aside-item/variation (first (get items-gpd v-uuid))))]
              [:div
               (keepaside-product-slat
                 {:qty (:scanned-qty scanned)
                  :brand (:product/brand-name (:item-line/product details))
                  :product (:product/name-ex-brand (:item-line/product details))
                  :feature (:variation/features (:item-line/variation details))})]))
          items-scanned)]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn #(t/transition-next app-atom :keepaside/outbound-move)}))))

(defmethod flow/render-screen :keepaside/outbound-scanlist [app-atom]
  (keepaside-outbound-scanlist app-atom))


;; Outbound 05 (Move items)
(rum/defc keepaside-outbound-move < rum/reactive
  [app-atom]
  (let [confirmed-atom (rum/cursor-in app-atom [:keep-aside :outbound :confirmed?])
        confirmed? (rum/react confirmed-atom)]
    (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :move-items}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Move Items Back To Store"]]
       [:div
        {:class (u/bem :section [:medium])}
        [:i.u-block-center
         {:class (u/bem :icon [:light-force :location :enormous :block])}]
        [:div.u-margin-top-24
         (feedback/action-feedback :info "Moved items back to store?" "" confirmed-atom {})]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when confirmed?
           #(grid/dispatch-action app-atom :keepaside/outbound-resolve {}))}))))

(defmethod flow/render-screen :keepaside/outbound-move [app-atom]
  (keepaside-outbound-move app-atom))


;; Outbound 06 (Finish)
(rum/defc keepaside-outbound-done < rum/reactive
  [app-atom]
  (w/wrapper app-atom "Keep Aside" {:steps outbound-steps :step :done}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:large :flush])}
        [:b "You've moved that back into stock."]]
       [:p.paragraph.u-text-center "The stock now available for sale to the customer."]]]]

    []

    (grid/pos-call-to-action
      {:single-fn #(t/transition-next app-atom :keepaside)})))

(defmethod flow/render-screen :keepaside/outbound-done [app-atom]
  (keepaside-outbound-done app-atom))


(defmethod grid/action :keepaside/outbound-resolve [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [order (get-in @app-atom [:keep-aside :outbound :lookup :order])]

    (comms/send :pos/keepaside-outbound-resolve-order
      {:order
       {:ent/uuid (:ent/uuid order)
        :items (mapcat #(map :ent/uuid (second %)) (:items order))}})))

(defmethod comms/receive :pos/keepaside-outbound-resolve-order [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:success e)
    (swap! app-atom update :keep-aside dissoc :outbound)
    (t/transition-next app-atom :keepaside/outbound-done)))


;; ===========================================
;; ============ Outbound End =================
;; ===========================================



;; ===========================================
;; ============ Replenish Start ==============
;; ===========================================
;; Replenish 01 (Replenish List)
(rum/defc keepaside-replenish-list < rum/reactive
  [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :replenish :items])]
    (w/wrapper app-atom "Keep Aside" {:steps replenish-steps :step :pick-items}
      (cond
        (not-empty items-gpd)
        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:flush :standard])}
           "Items To Book Back Into Stock"]]

         [:div.slats
          (map
            (fn [[v-uuid item]]
              (let [details (:variation/details (:keep-aside-item/variation (first item)))]
                (cards/product-card
                  {:hide-price? true :hide-options? true :stocktake-preview? true}
                  {:image {:public_id (:doc/public-id (:ent/image (:item-line/variation details)))}
                   :on-click
                   #(grid/dispatch-action app-atom :keepaside/replenish-scans {:v-uuid v-uuid})
                   ;:keepaside_progress :inprogress
                   :keepaside_needed (str (count item) " to put back")
                   :brand (:product/brand-name (:item-line/product details))
                   :title (:product/name-ex-brand (:item-line/product details))
                   :feature (:variation/features (:item-line/variation details))})))
            items-gpd)]]

        :else
        [[:div.section
          [:h2.u-text-center
           {:class (u/bem :heading [:standard])}
           "There are no items to put back"]

          [:div
           [:i.u-block-center
            {:class
             (u/bem
               :icon
               [:block :enormous :light-force :emoticon-happy :is-dark])}]]]])

      [(when-not (not-empty items-gpd)
         [:aside.page-body__footnote
          [:p.u-text-center
           {:class (u/bem :paragraph [:flush])}
           "The POS app will notify you when any Keep Aside orders expire. There's nothing here for now."]])]

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :keepaside/replenish-list [app-atom]
  (keepaside-replenish-list app-atom))

(defmethod grid/action :keepaside/replenish-items-list [app-atom {:keys [scan]}]
  (swap! app-atom update :keep-aside dissoc :replenish)

  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/keepaside-replenish-items-list
    {:session-uuid (:session-uuid @app-atom) :barcode scan}))

(defmethod comms/receive :pos/keepaside-replenish-items-list [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:keep-aside :replenish :items] (:items e))
  (t/transition-next app-atom :keepaside/replenish-list))


;; Replenish 02 (Scans)
(defmethod grid/action :keepaside/replenish-scans [app-atom {:keys [v-uuid]}]
  (swap! app-atom assoc-in [:keep-aside :replenish :selected-variation-uuid] v-uuid)
  (t/transition-next app-atom :keepaside/replenish-scans))


(rum/defc keepaside-replenish-scans < rum/reactive [app-atom]
  (let [items-gpd (cmn/curact app-atom [:keep-aside :replenish :items])
        selected-variation-uuid (cmn/curact app-atom [:keep-aside :replenish :selected-variation-uuid])
        selected-variaton (get items-gpd selected-variation-uuid)
        details (:variation/details (:keep-aside-item/variation (first selected-variaton)))
        scanned-qty (cmn/curact app-atom [:keep-aside :replenish :scanned-variations selected-variation-uuid :scanned-qty])]

    (w/wrapper app-atom "Keep Aside"
      {:steps replenish-steps
       :step :scan-items
       :modal-fn keepaside-replenish-menu-modal}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Scan Items"]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count
           (str (or scanned-qty 0) " / " (count selected-variaton))]
          [:img.product-card__image
           {:src (u/cloudinary (:doc/public-id (:ent/image (:item-line/variation details))) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand (:product/brand-name (:item-line/product details))]
           [:span.product-card__name (:product/name-ex-brand (:item-line/product details))]]
          (when (u/presence (:variation/features (:item-line/variation details)))
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation (:variation/features (:item-line/variation details))]])
          [:div.product-card__barcode
           "Code: " [:b.u-barcode.u-block (:variation/code (:item-line/variation details))]]]]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when (= (or scanned-qty 0) (count selected-variaton))
           #(t/transition-next app-atom :keepaside/replenish-move))}))))


(defmethod flow/render-screen :keepaside/replenish-scans [app-atom]
  (keepaside-replenish-scans app-atom))

(defmethod flow/barcode-dispatch-screen :keepaside/replenish-scans [_ app-atom scan]
  (grid/dispatch-action app-atom :keepaside/replenish-variation-scan {:scan scan}))

(defmethod grid/action :keepaside/replenish-variation-scan [app-atom {:keys [scan]} _]
  (sound/play :scan)
  (toaster/open-subtle-progress app-atom)

  (let [items-gpd (get-in @app-atom [:keep-aside :replenish :items])
        current-variation-uuid (get-in @app-atom [:keep-aside :replenish :selected-variation-uuid])
        scanned-variations (get-in @app-atom [:keep-aside :replenish :scanned-variations])
        max-count (count (get items-gpd current-variation-uuid))
        scanned-variation-qty (:scanned-qty (get scanned-variations current-variation-uuid))]

    (comms/send :pos/keepaside-replenish-variation-scan
      {:scan scan
       :max-scans max-count
       :scanned-qty (or scanned-variation-qty 0)
       :current-variation-uuid current-variation-uuid})))

(defmethod comms/receive :pos/keepaside-replenish-variation-scan [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (when (:success e)
    (swap! app-atom assoc-in [:keep-aside :replenish :scanned-variations (:current-variation-uuid e) :scanned-qty] (:scanned-qty e))))


;; Replenish 03 (Move items)
(rum/defc keepaside-replenish-move < rum/reactive
  [app-atom]
  (let [confirmed-atom (rum/cursor-in app-atom [:keep-aside :replenish :confirmed?])
        confirmed? (rum/react confirmed-atom)]
    (w/wrapper app-atom "Keep Aside" {:steps replenish-steps :step :move-items}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "Move Items Back To Store"]]

       [:div
        {:class (u/bem :section [:medium])}
        [:i.u-block-center
         {:class (u/bem :icon [:light-force :location :enormous :block])}]
        [:div.u-margin-top-24
         (feedback/action-feedback :info "Moved items back to store?" "" confirmed-atom {})]]]

      []

      (grid/pos-call-to-action
        {:single-text "Next"
         :single-style :primary
         :single-icon-right :arrow-right
         :single-fn
         (when confirmed?
           #(grid/dispatch-action app-atom :keepaside/replenish-done {}))}))))

(defmethod flow/render-screen :keepaside/replenish-move [app-atom]
  (keepaside-replenish-move app-atom))

;; Replenish 04 (Finish)
(rum/defc keepaside-replenish-done < rum/reactive
  [app-atom]
  (w/wrapper app-atom "Keep Aside" {:steps replenish-steps :step :done}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:large :flush])}
        [:b "You've moved that back into stock."]]]]]

    [[:aside.page-body__footer
      [:p.u-text-center
       {:class (u/bem :paragraph [:flush :large])}
       [:a.text-link {:on-click #(t/transition-next app-atom :keepaside)}
        "Done moving items for now"]]]]

    (grid/pos-call-to-action
      {:single-text "Next Item"
       :single-icon-right :arrow-right
       :single-fn #(grid/dispatch-action app-atom :keepaside/replenish-items-list nil)})))

(defmethod flow/render-screen :keepaside/replenish-done [app-atom]
  (keepaside-replenish-done app-atom))

(defmethod grid/action :keepaside/replenish-done [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [current-variation-uuid (get-in @app-atom [:keep-aside :replenish :selected-variation-uuid])
        scanned-qty (:scanned-qty (get-in @app-atom [:keep-aside :replenish :scanned-variations current-variation-uuid]))]

    (comms/send :pos/keepaside-replenish-move-variations
      {:variation-uuid current-variation-uuid
       :scanned-qty scanned-qty})))

(defmethod comms/receive :pos/keepaside-replenish-move-variations [app-atom e]
  (toaster/close-subtle-progress app-atom)

  (when (:success e)
    (swap! app-atom update :keep-aside dissoc :replenish)
    (t/transition-next app-atom :keepaside/replenish-done)))

;; ===========================================
;; ============ Replenish End ================
;; ===========================================


;; ===========================================
;; ========== All Requests Start =============
;; ===========================================

(defn request-slat [app-atom [_ request]]
  (let [user (first request)
        item-count (reduce + 0 (map :keep-aside-order/item-count request))]
    [:article.slat.collect-order-slat
     {:on-click
      #(grid/dispatch-action app-atom :keepaside/view-request
         {:store-uuid (:ent/uuid (:keep-aside-order/store user))
          :user
          {:fullname (str (:contact/firstname user) " " (:contact/lastname user))
           :email (:contact/email user)
           :phone (:contact/telephone user)}})}
     [:div
      {:class (u/bem :flex-grid-group [:flush :align-left])}
      [:div
       {:class (u/bem :flex-grid-block [:flush :fluid])}
       [:div.flex-grid-content
        [:ul.collect-order-slat__details
         [:li.collect-order-slat__customer
          [:span.u-hidden-from-view "Keep aside for: "]
          (:contact/firstname user)]
         [:li.collect-order-slat__email
          [:span.u-hidden-from-view "Email address: "]
          (:contact/email user)]]]]
      [:div
       {:class (u/bem :flex-grid-block [:align-right :flush :fluid])}
       [:div.flex-grid-content
        [:div.u-text-right
         [:p.collect-order-slat__location
          [:span.collect-order-slat__label "No. of items"]
          [:span (str item-count)]]]]]]]))

(rum/defc keepaside-all-requests-list < rum/reactive [app-atom]
  (let [request-list (cmn/curact app-atom [:keepaside :requests])
        current-warehouse-id (cmn/curact app-atom [:login :warehouse_id])
        warehouse-list (cmn/curact app-atom [:warehouse-list])
        current-warehouse-store (first (filter #(= current-warehouse-id (:warehouse-id %)) warehouse-list))

        search-string
        (if (cmn/curact app-atom [:keepaside-search])
          (str/lower-case (cmn/curact app-atom [:keepaside-search]))
          "")

        filtered-request-list
        (filter
          (fn [[user-email _]]
            (str/includes? (str/lower-case user-email) search-string))
          request-list)]

    (w/wrapper app-atom "Keep Aside" {:steps all-request-steps :step :request-list}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         "All Keep Aside Requests"
         [:span.u-hidden-from-view " "]
         [:span.heading__subtext "for the " (:displayname current-warehouse-store) " store"]]]
       [:div.slats
        [:div.card.form-field-card
         (forms/input "Filter requests by email address:" "jane.doe@domain.com"
           (rum/cursor app-atom :keepaside-search)
           {:type :user})]

        (map
          (partial request-slat app-atom)
          filtered-request-list)]]

      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :keepaside/all-requests [app-atom]
  (keepaside-all-requests-list app-atom))

(defmethod grid/action :keepaside/all-requests-list [app-atom]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/keepaside-all-requests
    {:store-id (cmn/curact app-atom [:login :store_id])}))

(defmethod comms/receive :pos/keepaside-all-requests [app-atom {:keys [requestlist]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom assoc-in [:keepaside :requests] requestlist)
  (t/transition-next app-atom :keepaside/all-requests))

(defmethod comms/receive :pos/cancel-keepaside-request [app-atom _]
  (grid/dispatch-action app-atom :keepaside/all-requests-list nil))

(defmethod grid/action :keepaside/confirm-cancel-request [app-atom config _]
  (comms/send :pos/cancel-keepaside-request
    {:order-uuid (:order-uuid config)}))

(defmethod grid/action :keepaside/remove-request [app-atom config _]  [_ _ _]
  (grid/confirm-modal app-atom
    {:title "Are you sure you want to cancel this request?"
     :text
     [[:p.paragraph "This will cancel the " [:b "entire"] " Keep Aside request and all the items."]
      [:p.paragraph.paragraph--flush [:b "Note:"] " You'll need to move ready items back into the store manually. No need to scan."]]
     :order-uuid (:order-uuid config)
     :confirm-key :keepaside/confirm-cancel-request}))

(defn keepaside-remove-request-modal [app-atom order-uuid]
  (grid/menu-modal app-atom
    {:order-uuid order-uuid
     :items
     [{:label "Remove Entire Request"
       :action :keepaside/remove-request
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :keepaside/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :keepaside/item-remove-confirm [app-atom config _]
  (comms/send :pos/cancel-keepaside-item
    {:item-uuid (:item-uuid config)}))

(defmethod comms/receive :pos/cancel-keepaside-item [app-atom {:keys [success customer-requests]}]
  (cond
    (not (empty? customer-requests))
    (swap! (cmn/process-cursor app-atom) assoc :customer-requests customer-requests)

    :else
    (grid/dispatch-action app-atom :keepaside/all-requests-list {})))

(defmethod grid/action :keepaside/remove-item [app-atom config _]  [_ _ _]
  (let [title (:product/name-ex-brand (:item-line/product (:variation/details (:keep-aside-item/variation (:item config)))))
        item-status (:ent/display-name (:keep-aside-item/status (:item config)))]
    (grid/confirm-modal app-atom
      {:title "Are you sure you want to remove this item?"
       :text [[:p.paragraph "The following item - " [:b title] " - will be removed from this keep aside request."]
              (when (= "Ready" item-status)
                [:p.paragraph.paragraph--flush [:b "Note:"] " You'll need to move this item back into the store manually. No need to scan."])]
       :item-uuid (:ent/uuid (:item config))
       :negative true
       :confirm-key :keepaside/item-remove-confirm})))

(defn request-item-modal [app-atom item]
  (grid/menu-modal app-atom
    {:item item
     :items
     [{:label "Remove Item from Request"
       :action :keepaside/remove-item
       :style
       {:full true :large true :negative true
        :icon-left :delete :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :keepaside/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defn request-header [app-atom {:keys [title order-uuid date items status email-sent?]}]
  [:div.slat-group-summary
   {:class
    (u/bem :slat
      [(cond
         (= status "Resolved")
         [:success-bg :success]

         (= status "Ready")
         [:success-bg :success]

         (= status "Expired")
         [:error-bg :error]

         (= status "Cancelled")
         [:error-bg :error]

         :else
         [:warning-bg :warning])
       :no-hover])}
   [:div.slat-group-summary__content
    [:h3.slat-group-summary__heading
     [:b (str title ":")]
     (str " " date " for " (inflections/pluralize items "item"))]
    [:p.slat-group-summary__status
     "Status: "
     (case status
       "Resolved"
       [:span.u-text-status-success "Resolved"]

       "Ready"
       [:span.u-text-status-success "Ready"]

       "Expired"
       [:span.u-text-status-error "Expired"]

       "Cancelled"
       [:span.u-text-status-error "Cancelled"]

       "Placed"
       [:span.u-text-status-warning "Placed"])
     (when email-sent?
       " | Email sent")]]
   (when
     (contains? #{"Placed" "Ready"} status)
     [:div.slat-group-summary__options
      [:button.slat-group-summary__button
       {:type "button"
        :on-click #(keepaside-remove-request-modal app-atom order-uuid)
        :class (u/bem :button [:has-icon-only :secondary :flat :standard])}
       [:i
        {:class (u/bem :icon [:dots-menu :block :default])}
        [:span.u-hidden-from-view "Open options menu"]]]])])

(rum/defc keepaside-view-request < rum/reactive [app-atom]
  (let [customer-requests (cmn/curact (cmn/process-cursor app-atom) [:customer-requests])
        [_ order] (first customer-requests)]

    (w/wrapper app-atom "Keep Aside" {:steps all-request-steps :step :view-request}
      [[:div
        {:class (u/bem :section [:medium])}
        [:h2.u-text-center
         {:class (u/bem :heading [:flush :standard])}
         (str "Requests from: " (:keep-aside-order/customer order))
         [:span.u-hidden-from-view " "]
         [:span.heading__subtext (:contact/email order)]
         [:span.heading__subtext (:contact/telephone order)]]]

       (map-indexed
         (fn [idx [_ order]]
           (vec
             (concat
               [:section.slats.product-card-group
                (request-header app-atom
                  {:title (str "Request " (inc idx))
                   :order-uuid (:ent/uuid order)
                   :status (:keep-aside-order/status order)
                   :items (:keep-aside-order/item-count order)
                   :date (ud/format-date (:keep-aside-order/date-expires order) "YYYY-MM-dd")
                   :email-sent? (:keep-aside-order/date-collection-email order)})]
               (map
                 (fn [item]
                   (let [item-details (:variation/details (:keep-aside-item/variation item))]
                     (cards/keepaside-item-card
                       {:hide-options? false
                        :options-fn
                        (when
                          (contains?
                            #{"Placed" "Ready"}
                            (:ent/display-name (:keep-aside-item/status item)))
                          #(request-item-modal app-atom item))}
                       {:image {:public_id (:doc/public-id (:ent/image (:item-line/variation item-details)))}
                        :keepaside_progress (:ent/display-name (:keep-aside-item/status item))
                        :keepaside_needed "" #_(:keep-aside-order/item-count order)
                        :brand (:product/brand-name (:item-line/product item-details))
                        :title (:product/name-ex-brand (:item-line/product item-details))
                        :feature (:variation/features (:item-line/variation item-details))})))
                 (mapcat second (:keep-aside-order/items-gpd order))))))
         customer-requests)]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :keepaside/view-request [app-atom]
  (keepaside-view-request app-atom))

(defmethod comms/receive :pos/keepaside-customer-requests [app-atom {:keys [customer-requests]}]
  (swap! (cmn/process-cursor app-atom) assoc :customer-requests customer-requests)
  (t/transition-next app-atom :keepaside/view-request))

(defmethod grid/action :keepaside/view-request [app-atom {:keys [store-uuid user]}]
  (comms/send :pos/keepaside-customer-requests {:store-uuid store-uuid :user user}))
